module.exports = __webpack_public_path__ + "img/input_6.6a8443c4.png";